export default __webpack_public_path__ + "static/media/carousel-img-4.cb2506b2.png";